/* ==========================================================================
   Tresnova — cart open/close state

   Flags <body> while the Corner app cart is open, so the stylesheet can move
   floating widgets out of its way. The WhatsApp bubble sits at
   z-index 999999999 - far above the cart's 5000 - and would otherwise float
   over the cart panel and its checkout button.

   Scope is deliberately narrow: this only listens to Corner's own
   onCowiOpen / onCowiClose events. It does not touch the cart button or
   change how the cart opens.
   ========================================================================== */

(function () {
  var OPEN_CLASS = 'tn-cart-open';

  function cornerReady() {
    return !!(window.corner && typeof window.corner.on === 'function');
  }

  function bind() {
    if (!cornerReady()) return false;
    try {
      window.corner.on('onCowiOpen', function () {
        document.body.classList.add(OPEN_CLASS);
      });
      window.corner.on('onCowiClose', function () {
        document.body.classList.remove(OPEN_CLASS);
      });
      return true;
    } catch (e) {
      return false;
    }
  }

  // The app bootstraps asynchronously, so poll briefly rather than assume it
  // is ready. Gives up after ~10s instead of polling forever.
  if (!bind()) {
    var tries = 0;
    var poll = setInterval(function () {
      if (bind() || ++tries > 40) clearInterval(poll);
    }, 250);
  }
})();
